<script>
  import PageHero from '$lib/page/Hero.svelte';
  import Quote from '$lib/Quote.svelte';
  import PortfolioSingleFacts from '$lib/singlePortfolio/PortfolioFacts.svelte';
  import PortfolioPreview from '$lib/singlePortfolio/preview/Index.svelte';
  import PortfolioSingleFeatured from '$lib/singlePortfolio/PortfolioSingleFeatured.svelte';
  import PortfolioSingleRelated from '$lib/singlePortfolio/Related.svelte';
  import Back from '$lib/singlePortfolio/Back.svelte';
  import Seo from '$lib/Seo.svelte';
  import Faq from '$lib/faq/Index.svelte';

  export let page_hero;
  export let featured;
  export let preview;
  export let facts;
  export let quote;
  export let related;
  export let back;
  export let seo;
  export let faq;
</script>

<PageHero hero={page_hero} />
{#if featured}
  <PortfolioSingleFeatured {featured} />
{/if}
{#if facts}
  <PortfolioSingleFacts {facts} />
{/if}
{#if preview}
  <PortfolioPreview {preview} />
{/if}
{#if quote}
  <Quote {...quote} />
{/if}
{#if related}
  <PortfolioSingleRelated {related} />
{/if}
<Back {back} />
{#if seo}
  <Seo {seo} />
{/if}
{#if faq}
  <Faq {faq} />
{/if}
